import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from './color';
import { getPadding, PADDING_SCHEMA } from './padding';
const FIXED_WIDTHS_SCHEMA = z
    .tuple([z.number().nullish(), z.number().nullish(), z.number().nullish()])
    .optional()
    .nullable();
export const ColumnsPropsSchema = z.object({
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        padding: PADDING_SCHEMA,
        textAlign: z.enum(['left', 'center', 'right']).optional().nullable(),
    })
        .optional()
        .nullable(),
    props: z
        .object({
        fixedWidths: FIXED_WIDTHS_SCHEMA,
        columnsCount: z.number().optional().nullable(),
        columnsGap: z.number().optional().nullable(),
        contentAlignment: z.enum(['top', 'middle', 'bottom']).optional().nullable(),
        tableWidth: z.number().min(0).max(100).optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function ColumnsTable({ style, columns, props }) {
    var _e, _t;
    const wStyle = {
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
        color: (_t = style === null || style === void 0 ? void 0 : style.color) !== null && _t !== void 0 ? _t : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    const tableWidth = ((props === null || props === void 0 ? void 0 : props.tableWidth) > 0) ? `${props === null || props === void 0 ? void 0 : props.tableWidth}%` : 'auto';
    const blockProps = {
        columnsCount: props === null || props === void 0 ? void 0 : props.columnsCount,
        fixedWidths: props === null || props === void 0 ? void 0 : props.fixedWidths,
        columnsGap: props === null || props === void 0 ? void 0 : props.columnsGap,
        contentAlignment: props === null || props === void 0 ? void 0 : props.contentAlignment,
        tableWidth: props === null || props === void 0 ? void 0 : props.tableWidth,
    };
    const columnsHTML = columns.slice(0, props === null || props === void 0 ? void 0 : props.columnsCount).map((column, index) => (React.createElement(ColumnsTableCell, { key: index, index: index, props: blockProps, columns: columns })));
    return (React.createElement("div", { style: wStyle },
        React.createElement("table", { align: "center", width: tableWidth, cellPadding: "0", border: 0, style: { tableLayout: 'fixed', borderCollapse: 'collapse', margin: `0 ${(style === null || style === void 0 ? void 0 : style.textAlign) === 'right' ? '0' : 'auto'} 0 ${(style === null || style === void 0 ? void 0 : style.textAlign) === 'left' ? '0' : 'auto'}` } },
            React.createElement("tbody", { style: { width: tableWidth } },
                React.createElement("tr", { style: { width: tableWidth } }, columnsHTML)))));
}
function ColumnsTableCell({ index, props, columns }) {
    var _e, _t;
    const contentAlignment = props === null || props === void 0 ? void 0 : props.contentAlignment;
    const style = {
        boxSizing: 'content-box',
        verticalAlign: contentAlignment,
        paddingLeft: getPaddingBefore(index, columns.length, props),
        paddingRight: getPaddingAfter(index, columns.length, props),
        width: (_t = (_e = props.fixedWidths) === null || _e === void 0 ? void 0 : _e[index]) !== null && _t !== void 0 ? _t : undefined,
    };
    return React.createElement("td", { style: style }, columns[index]);
}
function getPaddingBefore(index, columnCount, { columnsGap }) {
    if (index === 0) {
        return 0;
    }
    return (columnsGap / 2);
}
function getPaddingAfter(index, columnCount, { columnsGap }) {
    if (index === (columnCount - 1)) {
        return 0;
    }
    return (columnsGap / 2);
}
//# sourceMappingURL=columns-table.js.map